import type { AnimalSensitivityEnum } from '@gql/graphql';
import type { SelectOption } from '@presentation/components';
import type { MouseEventHandler } from 'react';

export interface QuizFormValues {
  sensitivities?: AnimalSensitivityEnum[];
}
export interface QuizPageStep {
  question: string;
  answerType: string;
  propositions: SelectOption<string>[];
  tip?: string;
  skippable?: boolean;
}

export interface QuizPageData {
  currentStep: number;
  steps: QuizPageStep[];
  onNextClick?: MouseEventHandler;
  onPreviousClick?: MouseEventHandler;
  onAnswerSelect?: (answer: string | null) => void;
  answers: Record<number, string>;
}

export interface QuizPageProps extends QuizPageData {}
